module.exports = __webpack_public_path__ + "static/img/lxy.eef42d45.jpg";